import { setCurrentConversation } from "../currentConversation/setCurrentConversation"

export const FETCH_MORE_CONVERSATIONS_BEGIN   = "FETCH_MORE_CONVERSATIONS_BEGIN"
export const FETCH_MORE_CONVERSATIONS_SUCCESS = "FETCH_MORE_CONVERSATIONS_SUCCESS"
export const FETCH_MORE_CONVERSATIONS_FAILED  = "FETCH_MORE_CONVERSATIONS_FAILED"
export const REACHED_END_OF_CONVERSATIONS     = "REACHED_END_OF_CONVERSATIONS"

const fetchConversationMoreBeginAction   =  (payload) => ({ type: FETCH_MORE_CONVERSATIONS_BEGIN, payload })
const fetchConversationMoreSuccessAction =  (payload) => ({ type: FETCH_MORE_CONVERSATIONS_SUCCESS, payload })
const fetchConversationMoreBeginFailed   =  (payload) => ({ type: FETCH_MORE_CONVERSATIONS_FAILED, payload })
const reachedEndOfConversations          =  (payload) => ({ type: REACHED_END_OF_CONVERSATIONS, payload })

export const fetchMoreConversations = (shouldSetCurrentConversation=false, showLoading=true, page=1) => {
  return (dispatch, getState) => {
    const { organization } = getState()
    dispatch(fetchConversationMoreBeginAction({ loading: showLoading}))
    return $.ajax({
      url: `/api/staff/v1/conversations.json?page=${page}`,
      success:  response => {
        if(response.length == 0) {
          dispatch(reachedEndOfConversations())
        } else {
          dispatch(fetchConversationMoreSuccessAction(response))
          if (shouldSetCurrentConversation) dispatch(setCurrentConversation(response[0]))
        }
      },
      error: () => dispatch(fetchConversationMoreBeginFailed())
    })
  }
}